import { call, put } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import { editPoliciesByIdFailed, editPoliciesByIdSuccessful } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest, { getBodyJson } from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { OK } from '../../../configs/serverStatusCodes';
import { BACKEND_URL } from '../../../configs';
import { normalizePolicyPayload } from '../../../dto/PoliciesDTO';

export default function* editPoliciesById(action) {
  try {
    if (!action.payload || !action.payload.id) {
      throw new Error('ID not found');
    }
    const url = `${BACKEND_URL}/policies/${action.payload.id}`;
    const pool = normalizePolicyPayload(action.payload);
    delete pool.policy_id;
    const response = yield makeRequest(url, pool, action, 'PUT', true);
    if (response.status === OK) {
      const data = yield getBodyJson(response);
      yield put(editPoliciesByIdSuccessful());
      yield call(resolveActionPromise(action, data.data));
    } else {
      const data = yield getBodyJson(response);
      yield put(editPoliciesByIdFailed());
      yield call(rejectActionPromise(action, { ...data, code: response.status }));
    }
  } catch (e) {
    yield put(editPoliciesByIdFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
